import { APIConfig } from 'src/config';
import {
  FEATURE_INHIBIT_COMMUNITY_TRADES,
  FEATURE_INHIBIT_CONTRACTED_TRADES,
  FEATURE_INHIBIT_NOMINATED_TRADES,
  TRADE_TYPE_COMMUNITY, TRADE_TYPE_CONTRACTED,
  TRADE_TYPE_NOMINATED, TRADE_TYPE_RESIDUAL,
  TradeRuleStates,
} from 'src/util/constants';
import { getTradeRuleStateLabel, getTradeTypeLabel } from 'src/util/i18n/constants';

/**
 * Configuration mapping trade types to their corresponding feature flags.
 * TRADE_TYPE_RESIDUAL is always included (no feature flag).
 */
const TRADE_TYPE_FEATURE_MAP = [
  { type: TRADE_TYPE_CONTRACTED, feature: FEATURE_INHIBIT_CONTRACTED_TRADES },
  { type: TRADE_TYPE_NOMINATED, feature: FEATURE_INHIBIT_NOMINATED_TRADES },
  { type: TRADE_TYPE_COMMUNITY, feature: FEATURE_INHIBIT_COMMUNITY_TRADES },
];

/**
 * Builds trade type options for dropdown/select components based on feature flags.
 * @param {import('react-intl').IntlShape} intl - i18n intl object
 * @returns {object} Object mapping trade type constants to localized labels
 */
const buildTypesOptions = (intl) => {
  const apiConfig = APIConfig();

  // Residual type (always included)
  const typesOptions = {
    [TRADE_TYPE_RESIDUAL]: getTradeTypeLabel(intl, TRADE_TYPE_RESIDUAL),
  };

  // Add other trade types based on feature flags
  TRADE_TYPE_FEATURE_MAP.forEach(({ type, feature }) => {
    if (!apiConfig.feature(feature)) {
      typesOptions[type] = getTradeTypeLabel(intl, type);
    }
  });

  return typesOptions;
};

/**
 * Builds trade rule state options for dropdown/select components.
 * @param {import('react-intl').IntlShape} intl - i18n intl object
 * @returns {object} Object mapping trade rule state constants to localized labels
 */
export const buildTradeRuleStatesOptions = (intl) => {
  const statesOptions = {};

  TradeRuleStates.forEach((state) => {
    statesOptions[state] = getTradeRuleStateLabel(intl, state);
  });

  return statesOptions;
};

export default buildTypesOptions;
